import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TOrganization } from 'shared/types/TOrganizationsService';

const initialState: { organization: TOrganization | null } = {
  organization: null,
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganization: (_, { payload }: PayloadAction<TOrganization>) => ({
      organization: payload,
    }),
  },
});

export const { setOrganization } = organizationSlice.actions;
